import React, { useEffect, useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import { FeatureGridPanelModel } from "./FeatureGridPanelModel";
import { ProductKeyFeatureModel } from "../ShowcasePanel/ShowcasePanelModel";
import FeatureGridPanelItem from "./FeatureGridPanelItem/FeatureGridPanelItem";

import "./FeatureGridPanel.css";

const FeatureGridPanel: React.FC<{ blok: FeatureGridPanelModel }> = ({
  blok,
}) => {
  const [data, setData] = useState<ProductKeyFeatureModel[]>([]);

  useEffect(() => {
    setData(
      blok.entities &&
        blok.entities.length === 1 &&
        blok.entities[0].content?.keyFeatures &&
        blok.entities[0].content?.keyFeatures.length > 0 &&
        blok.keyFeatures?.length > 1
        ? blok.entities[0].content?.keyFeatures.filter(
            (x) => blok.keyFeatures.indexOf(x.id) > -1,
          ) || []
        : [],
    );
  }, [blok]);

  if (data?.length < 1) {
    return null;
  }

  return (
    <div
      {...storyblokEditable(blok)}
      className="feature-grid-panel"
      style={{ backgroundColor: blok.panelColour }}
    >
      <div
        className="feature-grid-panel-container"
        style={{ color: blok.textColor }}
      >
        {blok.title && (
          <h2 className="title h2">
            <span style={{ color: blok.titleColor }}>{blok.title}</span>
          </h2>
        )}
        {blok.subTitle && (
          <h3 className="sub-title h3">
            <span style={{ color: blok.subTitleColor }}>{blok.subTitle}</span>
          </h3>
        )}

        <div className={`feature-grid-panel-content ${blok.itemsClass}`}>
          {data.length > 0 &&
            data.map((item) => {
              return (
                <FeatureGridPanelItem
                  blok={item}
                  fgp={blok}
                  key={`feature-grid-panel-item-${item.id}`}
                ></FeatureGridPanelItem>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default FeatureGridPanel;
